module.exports = require("method-override");


/*****************
 ** WEBPACK FOOTER
 ** external "method-override"
 ** module id = 7
 ** module chunks = 0
 **/